import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="min-h-screen bg-white text-[#1a1a1a]">
      <Header />
      <main className="pt-[72px]">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
